import { Api } from "./Api";
import _ from "lodash";
import axios from "axios";
import {
    ControleVehicule,
    EntretienVehicule,
    VehiculeFlotte,
} from "../models/ControleVehicule";

export class ControleVehiculeApi extends Api {
    constructor() {
        super("controle-vehicule");
    }

    // --- Flotte ---
    getFlotte(params?: Object): Promise<Array<VehiculeFlotte>> {
        return axios
            .get(this.baseUrl + "controle-vehicule/flotte", { params: params })
            .then(function (response) {
                let res: Array<VehiculeFlotte> = [];
                if (response.data && response.data.data) {
                    res = _.map(response.data.data, function (v) {
                        return new VehiculeFlotte(v);
                    });
                }
                return res;
            });
    }

    saveFlotte(vehicule: VehiculeFlotte): Promise<VehiculeFlotte> {
        let payload = vehicule.serialize();
        let request = vehicule.id
            ? axios.put(
                  this.baseUrl + "controle-vehicule/flotte/" + vehicule.id,
                  payload
              )
            : axios.post(
                  this.baseUrl + "controle-vehicule/flotte",
                  payload
              );
        return request.then(function (response) {
            return new VehiculeFlotte(response.data.data);
        });
    }

    deactivateFlotte(vehiculeId: number): Promise<VehiculeFlotte> {
        return axios
            .delete(this.baseUrl + "controle-vehicule/flotte/" + vehiculeId)
            .then(function (response) {
                return new VehiculeFlotte(response.data.data);
            });
    }

    // --- Contrôles (rapports) ---
    getControles(params?: Object): Promise<Array<ControleVehicule>> {
        return this.getResources(params).then(function (response) {
            let res: Array<ControleVehicule> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (c) {
                    return new ControleVehicule(c);
                });
            }
            return res;
        });
    }

    getControle(id: number, params?: Object): Promise<ControleVehicule> {
        return this.getResource(id, params).then(function (response) {
            return new ControleVehicule(response.data.data);
        });
    }

    delete(id: number, raison: string): Promise<any> {
        return super.deleteResource(id, raison);
    }

    pdfUrl(id: number, action: string = "I"): string {
        return this.apiUrl + id + "/pdf/" + action;
    }

    planGaragesUrl(vehiculeId?: number, action: string = "I"): string {
        return vehiculeId
            ? this.apiUrl + vehiculeId + "/plan/" + action
            : this.apiUrl + "plan/" + action;
    }

    /**
     * Ouvre dans un nouvel onglet un endpoint protégé par JWT en passant par un
     * blob (l'en-tête Authorization est porté par axios, pas par window.open).
     */
    openInNewTab(url: string): Promise<void> {
        return axios
            .get(url, { responseType: "blob" })
            .then(function (response) {
                let blobUrl = URL.createObjectURL(response.data);
                window.open(blobUrl, "_blank");
            });
    }

    // --- Entretiens ---
    getEntretiens(params?: Object): Promise<Array<EntretienVehicule>> {
        return axios
            .get(this.baseUrl + "controle-vehicule/entretien", {
                params: params,
            })
            .then(function (response) {
                let res: Array<EntretienVehicule> = [];
                if (response.data && response.data.data) {
                    res = _.map(response.data.data, function (e) {
                        return new EntretienVehicule(e);
                    });
                }
                return res;
            });
    }

    saveEntretien(
        entretien: EntretienVehicule
    ): Promise<EntretienVehicule> {
        let payload = entretien.serialize();
        let request = entretien.id
            ? axios.put(
                  this.baseUrl + "controle-vehicule/entretien/" + entretien.id,
                  payload
              )
            : axios.post(
                  this.baseUrl + "controle-vehicule/entretien",
                  payload
              );
        return request.then(function (response) {
            return new EntretienVehicule(response.data.data);
        });
    }

    removeEntretien(entretienId: number): Promise<any> {
        return axios.delete(
            this.baseUrl + "controle-vehicule/entretien/" + entretienId
        );
    }

    // --- Stats ---
    getStats(params?: Object): Promise<any> {
        return axios
            .get(this.baseUrl + "controle-vehicule/stats", { params: params })
            .then(function (response) {
                return response.data.data;
            });
    }
}
